import { gql } from '@apollo/client'

export const transactionsGql = gql`
	query transactions(
		$page: Int
		$limit: Int
		$order: String
		$amount: Float
		$lpn: String
		$state: String
		$beginEnd: [String]
	) {
		transactions(
			page: $page
			limit: $limit
			order: $order
			amount: $amount
			lpn: $lpn
			beginEnd: $beginEnd
			state: $state
		) {
			list {
				_id
				amount
				currency
				state
				startDate
				endDate
				events {
					tag
					createdAt
				}
				site {
					address1
					address2
					name
					city
					zipcode
				}
				paymentRecordsEntity {
					consumer
					type
					subtype
					amount
					currency
					paymentDate
					externalRef
					internalRef
				}
				paymentTransactionsEntity {
					type
					consumer
					reference
					psp
					amount
					currency
					status
					pspTransactionDate
					paymentMethod {
						pan
					}
				}
				consumer
				error {
					code
					message
				}
				durationDetails {
					p
					np
					f
				}
				vehicle {
					lpn
				}
				tariffCode
				paymentMethod
			}

			paging {
				count
				current
				limit
			}
		}
	}
`
